import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="container-editorial flex flex-1 flex-col items-center justify-center py-20 text-center">
        <span className="font-heading text-[7rem] font-black leading-none text-background-300 md:text-[10rem]">
          404
        </span>
        <h1 className="mt-4 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
          这条线索暂时找不到
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          页面可能已被移除，或者链接有误。你可以回到首页，或者直接去爆料中心翻一翻。
        </p>
        <p className="mt-2 rounded-md bg-background-100 px-3 py-1.5 font-mono text-xs text-foreground-500">
          {location.pathname}
        </p>
        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
          >
            <i className="ri-home-4-line text-base" />
            返回首页
          </Link>
          <Link
            to="/rumors"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-fire-line text-base" />
            浏览爆料中心
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}